module.exports = __webpack_public_path__ + "static/media/schedule.c9fe699f.svg";